(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sussi-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize = () => {
  if (window.sussiNavigationReady) return;
  const button = document.getElementById('sussi-back-top');
  if (!button) return;
  window.sussiNavigationReady = true;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.getElementById('sussi-embroidery');
  const source = root && root.querySelector('.se-chapters');
  const header = document.querySelector('.section-header');
  let floating, links = [], targets = [], pending = false, active = '';
  const headerBottom = () => {
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    const style = getComputedStyle(header);
    return /fixed|sticky/.test(style.position) && rect.top <= 1
      ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
  };
  if (source) {
    floating = source.cloneNode(true);
    floating.id = 'sussi-floating-chapters';
    floating.hidden = true;
    floating.setAttribute('aria-label', 'Embroidery chapters');
    document.body.appendChild(floating);
    const sourceLinks = [...source.querySelectorAll('a[href^="#"]')];
    links = [...floating.querySelectorAll('a[href^="#"]')];
    [...sourceLinks, ...links].forEach(link => {
      const label = link.textContent.trim();
      link.setAttribute('aria-label', label);
      const prefix = document.createElement('span');
      prefix.className = 'sussi-chapter-prefix';
      prefix.textContent = label.startsWith('The ') ? 'The' : '';
      link.textContent = label.replace(/^The /, '');
      link.prepend(prefix);
    });
    targets = links.map(a => document.getElementById(a.hash.slice(1)));
    const navigate = event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      const height = matchMedia('(max-width:767px)').matches ? 49 : 62;
      const top = Math.max(0, scrollY + target.getBoundingClientRect().top - headerBottom() - height - 20);
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      history.replaceState(null, '', link.hash);
      window.scrollTo({top, behavior: reduced() ? 'auto' : 'smooth'});
    };
    source.addEventListener('click', navigate);
    floating.addEventListener('click', navigate);
  }
  const update = () => {
    pending = false;
    button.toggleAttribute('data-visible', scrollY > 500);
    if (!floating) return;
    const offset = headerBottom();
    floating.style.setProperty('--sussi-nav-top', offset + 'px');
    const visible = source.getBoundingClientRect().top <= offset && root.getBoundingClientRect().bottom > offset + 120;
    floating.hidden = !visible;
    const line = offset + (matchMedia('(max-width:767px)').matches ? 49 : 62) + 32;
    let index = 0;
    targets.forEach((target,i) => { if (target && target.getBoundingClientRect().top <= line) index = i; });
    const current = links[index]?.hash;
    if (current !== active) {
      active = current;
      [links, [...source.querySelectorAll('a')]].forEach(group => group.forEach((link,i) => { if(i === index) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); }));
      const wrap = floating.firstElementChild;
      const selected = links[index];
      if (selected && wrap && wrap.scrollWidth > wrap.clientWidth) wrap.scrollLeft = Math.max(0,selected.offsetLeft - wrap.clientWidth/2 + selected.offsetWidth/2);
    }
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  button.addEventListener('click', () => {
    const focusTarget = document.querySelector('.skip-link') || document.querySelector('main');
    if (focusTarget) { if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex','-1'); focusTarget.focus({preventScroll:true}); }
    window.scrollTo({top:0,behavior:reduced()?'auto':'smooth'});
  });
  window.addEventListener('scroll',schedule,{passive:true,capture:true});
  window.addEventListener('pageshow',schedule);
  window.addEventListener('hashchange',schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize',schedule,{passive:true});
    window.visualViewport.addEventListener('scroll',schedule,{passive:true});
  }
  window.addEventListener('resize',schedule,{passive:true});
  if (header && 'ResizeObserver' in window) new ResizeObserver(schedule).observe(header);
  update();
 };
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
 else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
